import "@/App.css";
import { useLenis } from "@/components/portfolio/motion";
import { Navbar } from "@/components/portfolio/Navbar";
import { Banner } from "@/components/portfolio/Banner";
import { Hero } from "@/components/portfolio/Hero";
import { Vistas, Agriculture, Transport, FPV } from "@/components/portfolio/Sections";
import { Contact } from "@/components/portfolio/Contact";

function App() {
  useLenis();
  return (
    <div className="App grain min-h-screen bg-white text-slate-900">
      <Navbar />
      <main>
        <Banner />
        <Hero />
        <Vistas />
        <Agriculture />
        <Transport />
        <FPV />
        <Contact />
      </main>
    </div>
  );
}

export default App;
